import React from 'react'
import ReactPlayer from "react-player";

// Functional component for rendering a YouTube player
const YoutubePlayer = ({ url, playeris, width, height }) => {
    // Configuration object for the ReactPlayer component
    const playerConfig = {
        controls: true, // Show video controls
        playbackRate: 1.0, // Playback speed (1.0 is normal speed)
        volume: 0.8, // Volume (0.0 to 1.0)
        width: '100%', // Player width
        height: '100vh', // Player height
        loop: false, // Loop the video
        muted: false, // Mute the audio
        config: {
            youtube: {
                playerVars: {
                    autoplay: 1, // Auto-play the video
                    controls: 1, // Show video controls
                    modestbranding: 1, // Enable modest branding
                    rel: 0, // Hide related videos at the end
                    showinfo: 0, // Hide video title and info
                    autoplay: 1, // Auto-play the video
                },
            },
        },
    };

    return (
        <div className='videoplayerwrapperContainer'>
            {/* ReactPlayer component with the provided configuration and URL */}
            <ReactPlayer
                className="videoplayerwrapper embed-responsive embed-responsive-16by9"
                {...playerConfig}
                url={url}
            />
        </div>
    )
}

export default YoutubePlayer